<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '20px' }">
      <template #title>
        
        
        <a-list item-layout="horizontal" :data-source="['']">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta>
              <h5 slot="title" class="mt-5 mb-0 font-web font-bold">Submit Ticket</h5>
              <div slot="description"> 
                <h6 class="mt-0 mb-0 text-muted font-web">Submit a request to the MUIC IT Service Desk</h6>
              </div>
              <a-avatar
                 slot="avatar"
                shape="square"
                :size="64"
                :style="{ backgroundColor: '#ffffff', align: 'left' }"
              >
                <a-icon class="mt-5" style="font-size: 45px;color: #000000;" type="reconciliation" />
              </a-avatar>
            </a-list-item-meta>
          </a-list-item>
        </a-list>

      </template>

      <div class="mt-10 mb-10">
        <a-row>
          <a-col :xs="{ span: 5, offset: 1 }" :lg="{ span: 4  }"></a-col>
          <a-col :xs="{ span: 22, offset: 1 }" :lg="{ span: 12, offset: 0 }">
            
            <a-form-model layout="vertical" >

              <h6 class="font-bold font-web mt-0 mb-15"><a-icon class="mr-15" type="mail" />Email</h6>
              <a-form-model-item label="" 
                help="Please enter a valid email address so our staff can reach you.">
                <a-input type="email" v-model="formService.contact_mail" placeholder="enter email ..." />
              </a-form-model-item>
              <h6 class="font-bold font-web mt-20 mb-15"><a-icon class="mr-15" type="phone" />Phone number</h6>
              <a-form-model-item class="" label="" help="Not necessary ex: 0800547169">
                <a-input v-model="formService.contact_phone" placeholder="enter phone number ..." />
              </a-form-model-item>

              <h6 class="font-bold font-web mt-20 mb-15"><a-icon type="caret-right" class="mr-15" />What can we help you with ?</h6>
              <a-form-model-item class="" label="">
                <a-input v-model="formService.topic" placeholder="enter subject ..." />
              </a-form-model-item>
              <h6 class="font-bold font-web mt-0 mb-15"><a-icon type="unordered-list" class="mr-15" />Category</h6>
              <a-form-model-item label="">
                <a-select show-search placeholder="select Problemm type ..." option-filter-prop="children"
                  :filter-option="filterOption" v-model="formService.ticket_type">
                  <a-select-option v-for="item in optionCategory" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>

              

              <h6 class="font-bold font-web mt-0 mb-15"><a-icon type="edit" class="mr-15" />Tell us more about the issue:</h6>
              <a-form-model-item label="">
                <a-textarea v-model="formService.message" placeholder="Describe what’s happening ..." :rows="4" />
              </a-form-model-item>
              
               
              <h6 class="font-bold font-web mt-0 mb-15"><a-icon type="upload" class="mr-15" />Add a file if it helps:</h6>
              <a-form-model-item label="">

                <a-upload 
                  list-type="picture-card"
                  :file-list="fileList"
                  :remove="handleRemove" 
                  :before-upload="beforeUpload"
                  :multiple="false" 
                  accept="image/*;capture=camera"
                  v-model="formService.file_backup"
                >
                  <a-icon type="plus" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                </a-upload>

                
                <span>Attach files: (Button Upload) You can attach screenshots, documents, or anything that might help us resolve your issue faster.</span>
              </a-form-model-item>
             
              
              <a-form-model-item class="mt-50" label="">
                <a-button @click="submitService" type="primary" class="mr-10">
                  Submit
                </a-button>
                <a-button @click="backToService" type="danger"> Cancel </a-button>
                <a-alert class="mt-15 mb-20" type="info" show-icon>
                  <span slot="description">
                    Once submitted, you will receive a confirmation from our IT Service desk, typically within 24 business hours. If your issue is urgent or time-sensitive, <strong>please call 02 700 5000 Ext. 4555</strong>
                  </span>
                </a-alert>
              </a-form-model-item>

            </a-form-model>

          </a-col>
          <a-col :xs="{ span: 5, offset: 1 }" :lg="{ span: 6, offset: 2 }"></a-col>
        </a-row>
      </div>

      
    
      
      
      
    </a-card>
  </div>
</template>

<script>
const form = {
  topic: "",
  message: "",
  ticket_type: "",
  contact_phone: "",
  contact_mail: "",
  urgent: '',
  file_backup: null,
};
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
import authService from '../../services/authService';

export default {
  data() {
    return {
      formService: { ...form },
      optionCategory: [],
      // upload
      previewVisible: false,
      previewImage: '',
      fileList:[]
    };
  },
  computed: {},
  mounted() {
    // Priority 1: Keycloak email
    if (this.$keycloak && this.$keycloak.authenticated && this.$keycloak.tokenParsed) {
      this.formService.contact_mail = this.$keycloak.tokenParsed.email;
    } else {
      // Priority 2: MSAL email
      const msalAccount = authService.getAccount();
      if (msalAccount) {
        this.formService.contact_mail = msalAccount.username || '';
      }
    }
    this.getCatalogList();
  },
  methods: {

    // uploads
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file) {
      this.errorFile = "";
      if (
        file.type === "image/jpg" ||
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === ".heic" ||
        file.type === "image/png"
      ) {
        this.fileList = []
        this.formService.file_backup = file;
        this.fileList = [...this.fileList, file];
      } else {
        this.errorFile = "Found a Problem, please check your results.";
      }
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    backToService() {
      this.$router
        .push({
          path: "/service",
        })
        .catch((err) => {});
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleErrorCase(dataA, dataB) {
      this.$notification.open({
        style: {
          backgroundColor: "#ff1919",
          color: "#ffffff",
        },
        message: function (h) {
          return h("div", [h("strong", { class: "" }, `Error ${dataA}`)]);
        },
        description: `Problem issue connect api : ${dataB}`,
      });
    },
    async getCatalogList() {
      try {
        const res = await this.$http.get("/ticket/type/");
        if (res.status === 200) {
          this.optionCategory = res.data.map((item) => {
            return {
              id: item.id,
              text: item.detail,
            };
          });
        }
      } catch (error) {
        this.optionCategory = [];
        this.handleErrorCase(error.response.status, `/ticket/type/`);
      }
    },
    async submitService() {
      const sendData = new FormData();
      Object.entries(this.formService).forEach(([key, value]) => {
        sendData.append(key, value);
      });
      try {
        const response = await this.$http.post("/ticket/request/", sendData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status === 201) {
          try {
            const sendMsgComment = new FormData();
            sendMsgComment.append('msg_type', 'ask')
            sendMsgComment.append("message", this.formService.message);
            if(this.formService.file_backup !== null){
              sendMsgComment.append("upload_file", this.formService.file_backup);
            }else{
              sendMsgComment.append("upload_file", null);
            }
            const resCreateMsg = await this.$http.post(
              `/ticket/msg/push/${response.data.id}/`,
              sendMsgComment,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
            if (resCreateMsg.status === 201) {
              this.formService = { ...form };
              this.backToService();
            } else {
              const error = new Error('API Error');
              error.resCreateMsg = resCreateMsg;
              throw error;
            }
          } catch (error2) {
            this.handleErrorCase(
              error2.response.status,
              `/ticket/msg/push/${response.data.id}/`
            );
          }
        } else {
          const error = new Error('API Error');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.handleErrorCase(error.response.status, `/ticket/request/`);
      }
    },
  },
};
</script>

<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>